module.exports = __webpack_public_path__ + "0e9a1fac31df02677478997f5327e95e.svg";